import { request, METHOD } from '@/utils/request';
var BASE_URL = process.env.VUE_APP_API_BASE_URL;

/* 获取热词列表（410） */
export function gethotWordsList() {
  return request("".concat(BASE_URL) + "/searchkeyword", METHOD.GET);
}

/* 修改保存热词顺序（411） */
export function updateHotwordsSort(data) {
  return request("".concat(BASE_URL) + "/searchkeyword", METHOD.PUT, data);
}

/* 新增保存热词（413） */
export function addHotwords(data) {
  return request("".concat(BASE_URL) + "/searchkeyword", METHOD.POST, data);
}

/* 获取热词详情（414） */
export function gethotWordsDetail(id) {
  return request("".concat(BASE_URL) + "/searchkeyword/" + id, METHOD.GET);
}

/* 编辑保存热词详情（415） */
export function updatehotWordsDetail(id, data) {
  return request("".concat(BASE_URL) + "/searchkeyword/" + id, METHOD.PUT, data);
}

/* 删除热词（412） */
export function deleteHotWords(id, data) {
  return request("".concat(BASE_URL) + "/searchkeyword/" + id, METHOD.DELETE, data);
}
export default {
  gethotWordsList: gethotWordsList,
  updateHotwordsSort: updateHotwordsSort,
  addHotwords: addHotwords,
  gethotWordsDetail: gethotWordsDetail,
  updatehotWordsDetail: updatehotWordsDetail,
  deleteHotWords: deleteHotWords
};